
import { 
  IonPage, 
  IonHeader, 
  IonToolbar, 
  IonTitle, 
  IonContent,
  IonButtons,
  IonButton,
  IonBackButton,
  IonIcon,
  IonList,
  IonItem,
  IonLabel,
  IonSelectOption,

  onIonViewDidEnter
 } from '@ionic/vue';

import { checkmark, wineSharp } from 'ionicons/icons';

import { defineComponent, ref } from '@vue/runtime-core';
import { useRouter, useRoute } from 'vue-router';
import { isApiError, WeddingTask, WeddingTaskParams } from '@/lib/api-endpoints';
import MInput from '@/components/MInput.vue';
import MSelect from '@/components/MSelect.vue';
import MTextarea from '@/components/MTextarea.vue';
import { useStore } from '@/store';
import * as yup from 'yup';
import t from '@/translation';
import { useField, useForm } from 'vee-validate';
import budgetIcons from '@/lib/budget_icons';


export default  defineComponent({
  name: 'WeddingInfo',
  components: { 
    IonPage, 
    IonHeader, 
    IonToolbar, 
    IonTitle, 
    IonContent,
    IonButtons,
    IonButton,
    IonBackButton,
    IonIcon,
    IonList,
    //IonListHeader,
    //IonGrid,
    //IonRow,
    //IonCol,
    IonItem,
    IonLabel,
    //IonDatetime,
    IonSelectOption,
    //IonRadio,
    //IonRadioGroup,

    MInput,
    MSelect,
    MTextarea,
  },
  setup(_props){

    const store = useStore();
    const router = useRouter();
    const route = useRoute();

    const itemSchema = yup.object({
      title: yup.string().required().label(t("Task")),
      // eslint-disable-next-line @typescript-eslint/camelcase
      task_group_id: yup.number().required().label(t("Category")),
      notes: yup.string().label(t("Notes")),
    });

    // Create a form context with the validation schema
    const { values, validate, resetForm } = useForm({
      validationSchema: itemSchema,
    });
    
    // create a field for the icon because it does not use a prebuilt component
    const { errorMessage: importanceErrorMessage, value: importanceValue} = useField ("importance");

    const groupId = ref<number | undefined>(undefined);
    const itemId = ref<number | undefined>(undefined);
    const task = ref<WeddingTask | undefined>(undefined);

    // Load up the latest user details when entering this page
    onIonViewDidEnter(async () => {
      resetForm();
      // this page can be entered in one of three ways:
      // 1) with itemId and groupId -> update item
      // 2) with groupId only -> create new item in the specified group
      // 3) with no args -> create new item, no specified group.
      groupId.value = parseInt(route.params.todoCategoryId as string);
      itemId.value = parseInt(route.params.todoItemId as string);

      if ( itemId.value ){
        task.value = store.state.tasks.find( element => element.id == itemId.value );
        // populate the form with the details of the category to be edited.
        if (task.value){
          values.title = task.value.title;
          // eslint-disable-next-line @typescript-eslint/camelcase
          values.task_group_id = task.value.task_group.id;
          values.notes = task.value.notes;
        }
      } else if (groupId.value){
        // eslint-disable-next-line @typescript-eslint/camelcase
        values.task_group_id = groupId.value;
      } 
    });

    async function onSubmitForm(){
      const result = await validate();
      if (result.valid){

        const taskParams: WeddingTaskParams = {
          title: values.title!,
          // eslint-disable-next-line @typescript-eslint/camelcase
          task_group_id: values.task_group_id!,
          // eslint-disable-next-line @typescript-eslint/camelcase
          wedding_id: store.getters.wedding.id,
          id: itemId.value,
          notes: values.notes!,
        }

        const weddingTask = await store.dispatch('saveTask', taskParams);

        if (! isApiError(weddingTask)){
          router.go(-1); // go back to the last page.
          window.setTimeout(resetForm, 2000); // delayed so that validation errors are not seen before the page transistions.
        }

      
      } 
    }

    return {
      onSubmitForm,
      importanceValue,
      importanceErrorMessage,
      checkmark,
      wineSharp,
      budgetIcons,
      route,
      store,
      task,

    }
  }
});
